<template>
<div :class="{'rt-form-field rt-checkbox-field': true, 'rt-icon-checkbox': iconMark}">
    <label>
      <input type="checkbox" :checked="value" :disabled="disabled"
                  @change="$emit('input', $event.target.checked)"/>
      <span class="checkmark"></span>
      <span class="checkmark-text">
        <slot></slot>
      </span>
    </label>
</div>
</template>

<script>
  export default {
    props: {
      value: Boolean,
      iconMark: Boolean,
      disabled: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<style scoped lang="scss">

    @import './variables';

    .rt-form-field {
        position: relative;
        display: block;
        text-align: left;
    }

    input[type="checkbox"] {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
    }

    .rt-form-field label, .rt-checkbox-field label {
        cursor: pointer;
        font-size: 0.8rem;
        margin-left: 1.3rem;
    }

    .checkmark-text {
        line-height: 1.2rem;
        position: relative;
        bottom: 3px;
        right: 1px;
        color: $dark-blue;
    }

    .rt-checkbox-field input {
        margin-right: 0.4rem;
        position: relative;
        bottom: 0.1rem;
    }

    $checkbox-size: 1.2rem;

    .checkmark {
        position: absolute;
        top: 0;
        left: 0;
        height: $checkbox-size;
        width: $checkbox-size;
        background-color: $white;
        border: 1px solid $dark-blue;
        transition: all 0.2s ease-in-out;
    }

    .checkmark:after {
        transition: all 0.2s ease-in-out;
        content: "";
        position: absolute;
        display: none;
    }

    .rt-form-field input:checked ~ .checkmark:after {
        display: block;
    }

    /* Style the checkmark/indicator */
    .rt-form-field .checkmark:after {
        left: 6px;
        top: 1px;
        width: 7px;
        height: 13px;
        border: solid #fff;
        border-width: 0 2px 2px 0;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
    }

    .rt-form-field:hover input ~ .checkmark {
        background-color: $light-grey;
    }

    .rt-form-field input:checked ~ .checkmark {
        background-color: $primary-blue;
    }

    .rt-icon-checkbox {
        .checkmark {
            width: 1.37rem;
            height: 1.37rem;
            border-radius: 4px;
        }

        input:checked~.checkmark {
            background: $primary-dark-blue;
            border: 0;

            &::after {
                left: 6px;
                top: 6px;
                width: 10px;
                height: 10px;
                background: url('/assets/app/signup/icon-checkmark.svg');
                background-repeat: no-repeat;
                border: 0;
                transform: none;
            }
        }

        .checkmark-text {
            margin-left: 8px;
            top: -1px;
            font-size: 1rem;
            color: $grey-100;
            user-select: none;
        }
    }

    .bold {
        font-weight: bold;
    }
</style>
